import { IMultiDossierUnreadStatus, IUnreadStatus } from '../api/types';

export class UnreadStatus implements IUnreadStatus {
  readonly chat: { [groupId: string]: number; };

  constructor({ chat }: IUnreadStatus) {
    this.chat = { ...chat };
  }

  get total(): number {
    let count = 0;
    for (const groupIds in this.chat) {
      count += this.chat[groupIds];
    }
    return count;
  }
}

export class MultiDossierUnreadStatus implements IMultiDossierUnreadStatus {
  [dossierId: number]: UnreadStatus;

  constructor(data: IMultiDossierUnreadStatus) {
    for (const dossierId in data) {
      this[dossierId] = new UnreadStatus(data[dossierId]);
    }
  }

  get total(): number {
    let count = 0;
    for (const dossierId in this) {
      count += this[dossierId].total;
    }
    return count;
  }
}
